import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";

export interface ModalYesNoProps {
  size?: "sm" | "lg" | "xl";
  titleId: string;
  titleIdParams?: Record<string, string>;
  bodyTextId?: string;
  bodyTextIdParams?: Record<string, string>;
  showSignal: number;
  onYesClicked?: () => void;
  onClosed?: () => void;
}

export const ModalYesNo = (props: ModalYesNoProps) => {
  const {
    size,
    titleId,
    titleIdParams,
    bodyTextId,
    bodyTextIdParams,
    showSignal,
    onYesClicked,
    onClosed,
  } = props;
  const [display, setDisplay] = useState<boolean>(false);

  const handleClose = () => {
    setDisplay(false);
    onClosed && onClosed();
  };

  useEffect(() => setDisplay(showSignal > 0), [showSignal]);

  return (
    <Modal size={size ?? "lg"} show={display} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {titleIdParams ? (
            <FormattedMessage id={titleId} values={titleIdParams} />
          ) : (
            <FormattedMessage id={titleId} />
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bodyTextIdParams ? (
          <FormattedMessage id={bodyTextId} values={bodyTextIdParams} />
        ) : (
          <FormattedMessage id={bodyTextId} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          <FormattedMessage id="BOOLEAN.false" />
        </Button>
        <Button
          variant="success"
          onClick={() => {
            onYesClicked && onYesClicked();
            handleClose();
          }}
        >
          <FormattedMessage id="BOOLEAN.true" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
